import { createApp } from 'vue';
import OrfToAvifConverter from '../Components/OrfToAvifConverter.vue';

const root = document.getElementById('orf-to-avif-converter');
if (root) {
  createApp(OrfToAvifConverter).mount('#orf-to-avif-converter');
}
